module.exports = __webpack_public_path__ + "img/note.edfc14f2.svg";